<script>
    export let options = [];
    export let name = "";
    export let disabled = null;
    export let value = "";

    let d = null;
    $: {
      d = disabled ? true: null;        
    }
</script>

{#each options as o , i}
<div class="form-check form-check-inline" >
    <input
      class="form-check-input"
      type="radio"
      id={`${name}${i}`}
      value={o.value}
      name={name}
      disabled={d} 
      bind:group={value}      
      />
    <label class="form-check-label {d ? 'labeldisabled' : ''}" for={`${name}${i}`}>{o.label}</label>
  </div>
  {/each}